"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TurnMeterDecreaseEffectHandler = exports.TurnMeterDecreaseEffectArgs = void 0;
const Constants_1 = require("../../Constants");
const AttributeType_1 = require("../../enums/AttributeType");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
class TurnMeterDecreaseEffectArgs {
    constructor(amount, applyModifier = true) {
        this.amount = amount;
        this.applyModifier = applyModifier;
        this.__type = EffectType_1.EffectType.TurnMeterDecrease;
        this.__typeName = "TurnMeterDecrease";
        this.name = "Turn Meter Decrease";
        this.harmful = true;
    }
}
exports.TurnMeterDecreaseEffectArgs = TurnMeterDecreaseEffectArgs;
let TurnMeterDecreaseEffectHandler = class TurnMeterDecreaseEffectHandler {
    apply(sequence, container, state) {
        let amount = state.args.amount;
        if (state.args.applyModifier) {
            const [haste, hasteStacks, slowStacks] = container.getAttributeScores(state.targetId, [
                AttributeType_1.AttributeType.Haste,
                AttributeType_1.AttributeType.HasteStacks,
                AttributeType_1.AttributeType.SlowStacks,
            ]);
            amount = Math.round(amount * (1 + haste / Constants_1.Constants.HasteDivisor));
            const stacks = Math.min(10, Math.max(-10, hasteStacks - slowStacks));
            amount = stacks >= 10 ? 2 * amount
                : amount / (1 - .1 * stacks);
            // amount = amount * (1 + (.1 * (hasteStacks - slowStacks)));
        }
        const before = container.getTurnMeter(state.targetId);
        const after = Math.max(0, before - amount);
        container.setTurnMeter(sequence, state.targetId, after);
    }
    remove(sequence, container, state) { }
};
TurnMeterDecreaseEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.TurnMeterDecrease)
], TurnMeterDecreaseEffectHandler);
exports.TurnMeterDecreaseEffectHandler = TurnMeterDecreaseEffectHandler;
